export function shipmentPtlAssembleValidate(shipment){
    var result = true;

    result = validateId(shipment.id);
    result = validateUniqueOrderNumber(shipment.unique_order_number);
    result = validateShippingService(shipment.shipping_service);
    result = validateShipmentProductDetail(shipment.shipment_product_detail);
    result = validateClientId(shipment.client_id);

    return result;
}

function validateId(id) {    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateUniqueOrderNumber(unique_order_number) {
    if(typeof unique_order_number === 'string' && unique_order_number.trim() !== '') return true;
    else return false;
}

function validateShippingService(shipping_service) {
    if(typeof shipping_service === 'string' && shipping_service.trim() !== '') return true;
    else return false;
}

function validateShipmentProductDetail(shipment_product_detail) {
    if (shipment_product_detail) return true;
}

function validateClientId(client_id) {
    if(Number.isInteger(client_id)) return true;
    else return false;
}